import type { PositiveNumberMessages } from "web_myplann/Shared/Validation/Types/PositiveNumberMessages";
import { type ZodType, z } from "zod";

export const optionalPositiveFloat = (
	max: number,
	messages: PositiveNumberMessages,
): ZodType<number | null, z.ZodTypeDef, number | null | undefined> =>
	z
		.number()
		.gt(0, messages.positiveMessage)
		.max(max, messages.maxMessage)
		.nullish()
		.transform((val) => val ?? null);
